/** frontend Routes **/
import Homepage from '../pages/FrontendHomepage';
import Publicize from '../pages/FrontendPublicize';
import SummaryData from '../pages/FrontendSummaryData';

/** publicize Routes **/
import Publicize_News from '../pages/FrontendPublicize_News';
import Publicize_EEC from '../pages/FrontendPublicize_EEC';

import TypeAStudent from "../pages/TypeAStudent";
import TypeAStudentImportFile from "../pages/TypeAStudentImportFile";

const prefixApps = '/publicize/';

export const frontendRoutes = [
    /** frontend Routes **/
    { path: 'homepage', element: <Homepage /> },
    { path: 'publicize', element: <Publicize /> },
    { path: 'data-center', element: <SummaryData /> },
        
    /** publicize Routes **/
    { path: prefixApps+  'news/:newTypes/:id', element: <Publicize_News /> },
    { path: prefixApps+  'news/:newTypes/:id/:preview', element: <Publicize_News /> },
    { path: prefixApps+  'eec/:id', element: <Publicize_EEC /> },

];
